var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 333.2 343.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#9e19ab;stroke-miterlimit:10;stroke-width:4px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267.2,338.9H66.2c-.9-16.9,8.3-24.4,8.3-24.4H90.6l.9-53.4h27.2l30-33.7V203H144V184.3C69,171.2,74.6,16.6,74.6,16.6c31.9-14,92.1-12.2,92.1-12.2s60.2-1.8,92,12.2c0,0,5.6,154.6-69.3,167.7V203h-4.7v24.4l30,33.7h27.2l.9,53.4h16S268.1,322,267.2,338.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58,67.4s16.4,2.4,17.3-18.7c0,0-8.9-22.7-34.2-18.5,0,0-39,5.4-36.1,37.3s68.5,69.1,68.5,69.1,13.3,6.3-5.3,7.4c0,0-7,11.2,7.4,9.5s17.9-16.6,17.9-16.6S30.6,84.6,30.6,68.8c0,0-.3-15.8,21.1-17.2C51.7,51.6,72.8,50.2,58,67.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M275.4,67.4S259,69.8,258,48.7c0,0,8.9-22.7,34.2-18.5,0,0,39,5.4,36.2,37.3s-68.5,69.1-68.5,69.1-13.3,6.3,5.3,7.4c0,0,7,11.2-7.4,9.5s-17.9-16.6-17.9-16.6,62.9-52.3,62.9-68.1c0,0,.3-15.8-21.1-17.2C281.7,51.6,260.6,50.2,275.4,67.4Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard5);
export default __webpack_public_path__ + "static/media/card5.21293493080aaa6f541fdb787e50fb48.svg";
export { ForwardRef as ReactComponent };